import React, { useEffect, useState } from 'react';
import {
    Box,
    Grid,
    Avatar,
    Typography,
    TextField,
    Paper,
    Divider,
    Chip,
    Button,
} from '@mui/material';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import PersonIcon from '@mui/icons-material/Person';
import ChangePassword from '../pages/ChangePassword/ChangePassword';
import API from '../utils/Axios.utils';

export const Profile = () => {
    const user = JSON.parse(localStorage.getItem('userLoggedIn') || '{}');
    // Validation schemas
    const nameValidationSchema = Yup.object({
        firstName: Yup.string().required('First name is required'),
        lastName: Yup.string().required('Last name is required'),
    });
    const [firstname, setFirstName] = useState(user?.first_name);
    const [lastname, setLastName] = useState(user?.last_name);
    const [email, setEmail] = useState(user?.email);
    const [role, setRole] = useState('');
    const [orgName, setOrgName] = useState('');

    const fetchUserDetails = () => {
        const config = {
            headers: { Authorization: `Bearer ${user?.token}` },
        };
        if (user?.user_id) {
            API.get(`/api/users/user-details/${user?.user_id}`, config)
                .then((response) => {
                    // Uncomment when ready to use
                    const userData = response.data.user;
                    // setUser(userData);
                    setFirstName(userData.first_name);
                    setLastName(userData.last_name);
                    setEmail(userData.email);
                    setRole(userData.role_name);
                    setOrgName(userData.org_name);
                    // console.log('User details fetched:', response.data);
                })
                .catch((error) => {
                    console.log('Error fetching user details :- ', error);
                });
        }
    };

    useEffect(() => {
        fetchUserDetails();
    }, [])
    return (
        <Paper elevation={3} sx={{ p: 4, maxWidth: 900, mx: 'auto' }}>
            <Grid container spacing={2} alignItems="center" mb={4}>
                {/* Avatar + Name + Email */}
                <Grid item xs={12} md={8}>
                    <Box display="flex" alignItems="center">
                        <Avatar sx={{ width: 64, height: 64, bgcolor: '#1976d2', mr: 2 }}>
                            <PersonIcon sx={{ fontSize: 40 }} />
                        </Avatar>
                        <Box>
                            <Typography variant="h6" fontWeight="bold">
                                {firstname} {lastname}
                            </Typography>
                            <Typography color="text.secondary">{email}</Typography>
                        </Box>
                    </Box>
                </Grid>

                {/* Role Chip */}
                <Grid
                    item
                    xs={12}
                    md={4}
                    display="flex"
                    justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
                >
                    <Chip label={role} sx={{ color: '#1976d2' }} variant="outlined" />
                </Grid>
            </Grid>

            <Divider sx={{ my: 2 }} />

            <Box>
                {/* Formik Form for Name */}
                <Formik
                    initialValues={{ firstName: user?.first_name || '', lastName: user?.last_name || '', email: user?.email || '', org: orgName || '' }}
                    validationSchema={Yup.object({
                        firstName: Yup.string().required('First name is required'),
                        lastName: Yup.string().required('Last name is required'),
                        email: Yup.string().email('Invalid email').required('Email is required'),
                    })}
                    enableReinitialize={true}
                    onSubmit={(values) => {
                        const payload = {
                            first_name: values?.firstName || '',
                            last_name: values?.lastName || '',
                            email: values?.email || '',
                            role: user?.role || '',
                            org: orgName || ''
                        };
                        const config = {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        };

                        // API.patch(`edit-user/${user?.id}`, payload, config)
                        //     .then((res) => {
                        //         setFirstName(values?.firstName);
                        //         setLastName(values?.lastName);
                        //     })
                        //     .catch((err) => {
                        //         setFirstName(user?.first_name);
                        //         setLastName(user?.last_name);
                        //         console.log('Edit error :- ', err);
                        //     })
                    }}
                >
                    {({ touched, errors }) => (
                        <Form>
                            <Grid container spacing={3} mb={2}>
                                <Grid item xs={12} md={6}>
                                    <Field
                                        as={TextField}
                                        name="firstName"
                                        label="First name"
                                        fullWidth
                                        variant="outlined"
                                        error={touched.firstName && Boolean(errors.firstName)}
                                        helperText={<ErrorMessage name="firstName" />}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Field
                                        as={TextField}
                                        name="lastName"
                                        label="Last name"
                                        fullWidth
                                        variant="outlined"
                                        error={touched.lastName && Boolean(errors.lastName)}
                                        helperText={<ErrorMessage name="lastName" />}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        name="email"
                                        label="Email"
                                        fullWidth
                                        variant="outlined"
                                        error={touched.email && Boolean(errors.email)}
                                        helperText={<ErrorMessage name="email" />}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        name="org"
                                        label="Organization"
                                        fullWidth
                                        variant="outlined"
                                        error={touched.org && Boolean(errors.org)}
                                        helperText={<ErrorMessage name="org" />}
                                        disabled
                                    />
                                </Grid>
                            </Grid>

                            {/* <Box display="flex" justifyContent="flex-end">
                                <Button type="submit" variant="contained" sx={{
                                    backgroundColor: '#1976d2',
                                    '&:hover': {
                                        backgroundColor: '#1976d2'
                                    },
                                    mb: 4
                                }}
                                >
                                    Save Details
                                </Button>
                            </Box> */}
                        </Form>
                    )}
                </Formik>

                <Divider sx={{ my: 2 }} />

                <ChangePassword />
            </Box>
        </Paper>
    );
};

